import type { Theme } from '@mui/material/styles';
import base from './base';
import palette from './palette';

const calendar = {
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        width: '300px',
        padding: '16px',
      },
    },
  },
  MuiMonthCalendar: {
    styleOverrides: {
      root: {
        padding: 0,
        width: '267px',
        columnGap: 0,
        marginTop: '10px',
        '&:has(.MuiMonthCalendar-button:not(.Mui-selected):is(:hover, :focus)) .MuiMonthCalendar-button.Mui-selected:not(:hover)': {
          color: palette.primary.main,
          backgroundColor: 'transparent',
        },
      },
      button: ({ theme }: { theme: Theme }) => ({
        width: '89px',
        height: '35px',
        borderRadius: base.shape.borderRadius,
        padding: 0,
        transition: theme.transitions.create(['background-color', 'color'], {
          delay: theme.transitions.duration.shortest,
          duration: theme.transitions.duration.short,
        }),
        '&:focus, &.Mui-selected:focus': {
          color: palette.common.white,
          backgroundColor: palette.primary.main,
        },
        '&:hover': {
          color: palette.common.white,
          backgroundColor: palette.primary.light,
        },
        '&.Mui-selected': {
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          '&:hover': {
            color: palette.common.white,
            backgroundColor: palette.primary.main,
          },
        },
      }),
    },
  },
  MuiDayCalendar: {
    styleOverrides: {
      root: {
        '& .MuiDayCalendar-monthContainer': {
          '&:has(.MuiPickersDay-root:not(.Mui-selected):is(:hover, :focus)) .MuiPickersDay-root.Mui-selected:not(:hover)': {
            color: palette.primary.main,
            backgroundColor: 'transparent',
          },
        },
      },
      weekContainer: {
        margin: '8px 0',
        justifyContent: 'start',
      },
    },
  },

  MuiPickersDay: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        borderRadius: base.shape.borderRadius,
        width: '28px',
        height: '28px',
        margin: '0 5px',
        transition: theme.transitions.create(['background-color', 'color'], {
          delay: theme.transitions.duration.shortest,
          duration: theme.transitions.duration.short,
        }),
        '&:focus, &.Mui-selected:focus': {
          color: palette.common.white,
          backgroundColor: palette.primary.main + ' !important',
        },
        '&:hover': {
          color: palette.common.white,
          backgroundColor: palette.primary.light + ' !important',
        },
        '&.Mui-selected': {
          color: palette.common.white,
          backgroundColor: palette.primary.main,
          '&:hover': {
            color: palette.common.white,
            backgroundColor: palette.primary.main,
          },
        },
      }),
    },
  },
};
export default calendar;
